import { useCallback } from "react";
import { useApolloClient, gql } from "@apollo/client";
import {
  CreateToolsIA,
  CreateToolsIAVariables,
} from "../__generated__/gql-types/CreateToolsIA";

const CREATE_TOOLS_IA = gql`
  mutation CreateToolsIA($toolsIaInput: ToolsIAInput!) {
    createToolsIA(toolsIAInput: $toolsIaInput) {
      cover
      cover_en
      created_at
      deleted_at
      description
      description_en
      forms {
        example_text
        label
        number_of_lines
        section
      }
      forms_en {
        example_text
        label
        number_of_lines
        section
      }
      id
      prompt
      prompt_en
      title
      title_en
      updated_at
    }
  }
`;

const UseCreateToolsIA = () => {
  const client = useApolloClient();

  return useCallback(
    async (variables: CreateToolsIAVariables) => {
      return await client.mutate<CreateToolsIA>({
        mutation: CREATE_TOOLS_IA,
        fetchPolicy: "no-cache",
        variables,
      });
    },
    [client]
  );
};

export default UseCreateToolsIA;
